import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useDeleteEventMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();

  return useMutation({
    mutationFn: async (eventId) => {
      const result = await api.deleteEvent(eventId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to delete event');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    ...options,
  });
};
